/* eslint-disable no-prototype-builtins */
import * as React from 'react'
import axios from 'axios'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import Modal from '@mui/material/Modal'
import Divider from '@mui/material/Divider'
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined'
import AddIcon from '@mui/icons-material/Add'

import SelectMediaItem from '../items/SelectMediaItem'

import { positionChangeHeightSm, positionChangeWidthMd, positionChangeWidthSm, selectMediaItemDimension, swipelyticsPink, profileTypes, profileVibes, captionsArray } from '../../../../helpers/variableDefaults'
import { standardButton, exitModalIconButton } from '../../../../helpers/buttons'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { newSimulationTextField } from '../../../../helpers/textfields'
import { validEmail, dummyBoxWidth, removeDuplicatesFromArray, capitalizeFirstLetter, reloadView } from '../../../../helpers/globalHelpers'
import { standardErrorContainer } from '../../../../helpers/errors'
import { getTokenFromLocalStorage } from '../../../../helpers/storage'
import { selectElementHandleChange, selectMultiple } from '../../../../helpers/selects'
import { selectElementWithIndex, multiLineSelectElementWithIndex } from '../../../../helpers/selects'
import { doneAndCancelButtonsJSX } from '../../../../helpers/commonJSX'
import { advisoryTypography } from '../../../../helpers/typographies'
import { descriptionTextFieldNoIndexOrChangeHandler } from '../../../../helpers/textfields'

import { Input } from '../../../../helpers/globalHelpers'

export const selectMediaItemModalJSX = (
  user,
  datingProfile, setDatingProfile, 
  previousDatingProfile, setPreviousDatingProfile, 
  selectedMediaItemIndex, setSelectedMediaItemIndex, 
  newMediaItem, setNewMediaItem,
  openMediaItemSelectModal, setOpenMediaItemSelectModal,
  // videoThumbnail, videoDuration,
  videoIsLoading, setVideoIsLoading,
  customCaptionSelected, setCustomCaptionSelected, customSubcaptionSelected, setCustomSubcaptionSelected,
  loading, setLoading,
  errors, setErrors,
  saveSuccessful, setSaveSuccessful,
  width,
  mediaItemsModalRef,
  navigate
) => {
  // console.log('selectMediaItemModalJSX runs')
  // console.log('user ->', user)
  // console.log('previousDatingProfile.media ->', previousDatingProfile)
  // console.log('width ->', width)
  // console.log('selectedMediaItemIndex ->', selectedMediaItemIndex)
  const isNewItem = !('media' in datingProfile && datingProfile.media.length > selectedMediaItemIndex && 'mediaItemId' in datingProfile.media[selectedMediaItemIndex] && datingProfile.media[selectedMediaItemIndex].mediaItemId.length > 0)

  const getMediaItemOnUserById = () => {
    return user.media.filter(userMediaItem => userMediaItem._id === newMediaItem.mediaItemId)[0]
  }
  // console.log('getMediaItemOnUserById ->', getMediaItemOnUserById())

  const arrayOfCaptions = () => {
    const mediaCaptionsArray = customCaptionSelected || (getMediaItemOnUserById().captions.filter((itemCaption, itemCaptionIndex) => itemCaption.length > 0 && itemCaption !== 'No Caption').length === 0) ?
      [ ...captionsArray ]
      :
      removeDuplicatesFromArray([ 
        'No Caption', 
        ...getMediaItemOnUserById().captions,
        'Custom'
      ])

    if (!customCaptionSelected && newMediaItem.caption.length > 0 && mediaCaptionsArray.filter((captionInArray, captionInArrayIndex) => captionInArray === newMediaItem.caption).length === 0) {
      mediaCaptionsArray.splice(mediaCaptionsArray.length - 1, 0, newMediaItem.caption)
    }

    return mediaCaptionsArray
  }
  // console.log('arrayOfCaptions ->', arrayOfCaptions())

  const arrayOfSubcaptions = () => {
    const subcaptionsArray = removeDuplicatesFromArray([ 
      'No Subcaption', 
      ...getMediaItemOnUserById().subcaptions,
      'Custom'
    ])
    if (newMediaItem.subcaption.length > 0 && subcaptionsArray.filter((subcaptionInArray, subcaptionInArrayIndex) => subcaptionInArray === newMediaItem.subcaption).length === 0) {
      subcaptionsArray.splice(subcaptionsArray.length - 1, 0, newMediaItem.subcaption)
    }

    return subcaptionsArray
  }
  // console.log('arrayOfSubcaptions ->', arrayOfSubcaptions())

  const mediaItemURLsInDatingProfileArray = () => {
    return datingProfile.media.map((datingProfileMediaItem, datingProfileMediaItemIndex) => datingProfileMediaItem.mediaItemURL)
  }

  const handleClose = () => {
    // console.log('handleClose runs ->')
    // console.log('openMediaItemSelectModal ->', openMediaItemSelectModal)

    setNewMediaItem({})
    setSelectedMediaItemIndex(-1)
    setCustomCaptionSelected(false)
    setCustomSubcaptionSelected(false)
    setOpenMediaItemSelectModal(false)
  }

  const handleDone = async () => {
    console.log('handleDone runs')
    
    const newMediaItems = [ ...datingProfile.media ] 
    newMediaItems[selectedMediaItemIndex] = { ...newMediaItem }
    // console.log('newMediaItem ->', newMediaItem)
    // console.log('newMediaItems[selectedMediaItemIndex] ->', newMediaItems[selectedMediaItemIndex])
    setDatingProfile({ ...datingProfile, media: [ ...newMediaItems ] })

    setNewMediaItem({})
    setSelectedMediaItemIndex(-1)
    setCustomCaptionSelected(false)
    setCustomSubcaptionSelected(false)
    setOpenMediaItemSelectModal(false)
  }

  const handleChangeMediaItem = (e) => {
    e.preventDefault()
    console.log('handleChangeMediaItem runs')

    setErrors({ ...errors, selectMediaItem: false })

    const { name, value } = e.target
    console.log('name ->', name)
    console.log('value ->', value)

    // console.log('value.length ->', value.length)
    // console.log('typeof value ->', typeof value)
    // console.log('value.charAt(0) ->', value.charAt(0))
    
    if (value !== 'Custom') {
      setNewMediaItem({
        ...newMediaItem,
        [name]: value === 'No Subcaption' ? '' : value,
      })
    } else if (name === 'caption') {
      setCustomCaptionSelected(true)
    } else if (name === 'subcaption') {
      setCustomSubcaptionSelected(true)
    }
  }

  const selectMediaItem = (e, userMediaIndex) => {
    e.preventDefault()
    console.log('selectMediaItem runs')

    if (datingProfile.type === 'hinge') {
      setNewMediaItem({
        ...newMediaItem,
        mediaItemId: user.media[userMediaIndex]._id,
        mediaItemURL: user.media[userMediaIndex].url,
        mediaItemDuration: 'duration' in user.media[userMediaIndex] ? user.media[userMediaIndex].duration : -1,
        mediaItemThumbnail: 'videoThumbnailURL' in user.media[userMediaIndex] && user.media[userMediaIndex].videoThumbnailURL.length > 0 && user.media[userMediaIndex].videoThumbnailURL !== 'NA' ? user.media[userMediaIndex].videoThumbnailURL : 'NA',
        mediaType: user.media[userMediaIndex].type,
      })

      mediaItemsModalRef.current?.scrollTo(0, 20)
    } else {
      const newMediaItems = [ ...datingProfile.media ] 
      newMediaItems[selectedMediaItemIndex] = { 
        ...newMediaItem,
        mediaItemId: user.media[userMediaIndex]._id,
        mediaItemURL: 'portraitURL' in user.media[userMediaIndex] && user.media[userMediaIndex].portraitURL !== 'NA' ? user.media[userMediaIndex].portraitURL : user.media[userMediaIndex].url,
        mediaItemDuration: 'duration' in user.media[userMediaIndex] ? user.media[userMediaIndex].duration : -1,
        mediaItemThumbnail: 'videoThumbnailURL' in user.media[userMediaIndex] && user.media[userMediaIndex].videoThumbnailURL.length > 0 && user.media[userMediaIndex].videoThumbnailURL !== 'NA' ? user.media[userMediaIndex].videoThumbnailURL : 'NA',
        mediaType: user.media[userMediaIndex].type,
      }
      // console.log('newMediaItems[selectedMediaItemIndex] ->', newMediaItems[selectedMediaItemIndex])
      setDatingProfile({ ...datingProfile, media: [ ...newMediaItems ] })
  
      setNewMediaItem({})
      setSelectedMediaItemIndex(-1)
      setCustomCaptionSelected(false)
      setCustomSubcaptionSelected(false)
      setOpenMediaItemSelectModal(false)
    }
  }

  const selectedMediaItemDimension = (width) => {
    return width < 280 ? '200px' : width < 350 ? '250px' : width < 450 ? '300px' : width < 600 ? '300px' : width < 800 ? '300px' : '300px'
  }


  const doneButtonDisabled = () => {
    // console.log('doneButtonDisabled runs')
    // console.log('newMediaItem.mediaItemId.length ->', newMediaItem.mediaItemId.length)
    // console.log('newMediaItem.mediaItemURL.length ->', newMediaItem.mediaItemURL.length)
    // console.log('newMediaItem.mediaType.length ->', newMediaItem.mediaType.length)
    // console.log('newMediaItem.caption ->', newMediaItem.caption)
    // console.log('newMediaItem.subcaption ->', newMediaItem.subcaption)
    return ( 
      datingProfile.media.length > selectedMediaItemIndex 
        ?
        (
          newMediaItem.mediaItemId === datingProfile.media[selectedMediaItemIndex].mediaItemId
          && newMediaItem.mediaItemURL === datingProfile.media[selectedMediaItemIndex].mediaItemURL
          && newMediaItem.mediaType === datingProfile.media[selectedMediaItemIndex].mediaType
          && newMediaItem.caption === datingProfile.media[selectedMediaItemIndex].caption
          && newMediaItem.subcaption === datingProfile.media[selectedMediaItemIndex].subcaption
        )
        :
        (
          newMediaItem.mediaItemId.length === 0
          && newMediaItem.mediaItemURL.length === 0
          && newMediaItem.mediaType.length === 0
        )
    )
  }

  const handleAddNewMediaItem = () => {
    // console.log('handleAddNewMediaItem runs')
    navigate(`?media`, { state: { previousLocationPathname: `${window.location.pathname}?crop-media` } })
    window.scrollTo(0, 0)
    reloadView()
  }

  return (
    <Modal
      open={openMediaItemSelectModal}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
      sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}
    >
      <Box 
        ref={mediaItemsModalRef}
        sx={{ 
          // position: 'absolute',
          // left: '50%',
          // top: '50%',
          // transform: 'translate(-50%, -50%)',
          // width: width < positionChangeWidthSm ? '85%' : '450px',
          width: '85%',
          maxWidth: '500px',
          height: '85%',
          bgcolor: 'white',
          border: '2px solid #000',
          boxShadow: 24,
          p: 2, 
          overflowY: 'scroll',
          '&::-webkit-scrollbar': {
            WebkitAppearance: 'none',
            width: '8px',
          },
          '&::-webkit-scrollbar-thumb': {
            borderRadius: '4px',
            backgroundColor: 'rgba(0, 0, 0, .35)',
            webkitBoxShadow: '0 0 1px rgba(255, 255, 255, .5)',
          },
          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
        }}
      >
        <Box
          sx={{
            width: '100%', height: '100%',
            display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
          }}
        >
          {/* Exit Icon Button */}
          {newMediaItem.mediaItemId.length === 0 &&
            <Box
              sx={{
                mr: 0,
                width: '100%',
                display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center',
              }}
            >
              {exitModalIconButton(handleClose, false, 0, 1, 1)}
            </Box>
          }

          {/* List of Media Items or Current Media Item */}
          {newMediaItem.mediaItemId.length > 0 
            ?
            <Box
              sx={{
                mt: 2,
                width: '100%',
                display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  // width: '95%',
                  // maxWidth: '400px',
                  width: selectedMediaItemDimension(width),
                  boxShadow: 3, 
                  borderRadius: '5px',
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center',
                }}
              >

                <Box sx={{ width: '100%' }}>
                  <Input type="text" autoFocus="autoFocus" />
                </Box>

                {/* Caption Selected */}
                {multiLineSelectElementWithIndex(
                  'caption',
                  ``,
                  newMediaItem.caption === '' ? 'No Caption' : newMediaItem.caption,
                  arrayOfCaptions().indexOf(newMediaItem.caption === '' ? 'No Caption' : newMediaItem.caption),
                  // arrayOfCaptions.indexOf(newMediaItem.caption === '' ? 'No Caption' : newMediaItem.caption),
                  false,
                  true,
                  arrayOfCaptions(),
                  // arrayOfCaptions,
                  handleChangeMediaItem,
                  newMediaItem,
                  setNewMediaItem,
                  setErrors,
                  0,
                  0,
                  'white',
                  selectedMediaItemDimension(width)
                )}
        
                {/* Divider */}
                <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

                {/* Image/Video-thumbnail */}
                {newMediaItem.mediaType === 'image' 
                  ?
                  <Box 
                    sx={{ 
                      // mt: 1,
                      width: selectedMediaItemDimension(width),
                      height: selectedMediaItemDimension(width),
                      backgroundImage: `url(${newMediaItem.mediaItemURL})`,
                      backgroundSize: 'cover',
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center',
                      display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
                    }}
                  />
                  :
                  <>
                    <Box 
                      component="video" 
                      // controls 
                      // controlsList="nofullscreen"
                      // webkit-playsinline 
                      onLoadStart={() => setVideoIsLoading(true)}
                      onLoadedData={() => setVideoIsLoading(false)}
                      playsInline
                      src={newMediaItem.mediaItemURL} 
                      // allow="autoPlay"
                      autoPlay
                      loop
                      muted
                      sx={{ 
                        // my: 1,
                        width: selectedMediaItemDimension(width),
                        height: videoIsLoading ? 0 : selectedMediaItemDimension(width),
                        display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-end', 
                      }}
                    />
                    {videoIsLoading &&
                      <Box
                        sx={{
                          // position: 'relative',
                          color: 'blue',
                          width: selectedMediaItemDimension(width),
                          height: selectedMediaItemDimension(width),
                          display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                        }}
                      >
                        Video is Loading...
                      </Box>
                    }
                  </>
                }
        
                {/* Divider */}
                <Divider sx={{ width: '100%', my: 0 }} orientation="horizontal" />

                {/* Subcaption */}
                {!customSubcaptionSelected 
                  && getMediaItemOnUserById().subcaptions.filter((itemSubcaption, itemSubcaptionIndex) => itemSubcaption.length > 0 && itemSubcaption !== 'No Subcaption').length > 0
                  ?
                  multiLineSelectElementWithIndex(
                    'subcaption',
                    ``,
                    newMediaItem.subcaption === '' ? 'No Subcaption' : newMediaItem.subcaption,
                    arrayOfSubcaptions().indexOf(newMediaItem.subcaption === '' ? 'No Subcaption' : newMediaItem.subcaption),
                    // arrayOfSubcaptions.indexOf(newMediaItem.subcaption === '' ? 'No Subcaption' : newMediaItem.subcaption),
                    false,
                    true,
                    arrayOfSubcaptions(),
                    // arrayOfSubcaptions,
                    handleChangeMediaItem,
                    newMediaItem,
                    setNewMediaItem,
                    setErrors,
                    0,
                    0,
                    'white',
                    selectedMediaItemDimension(width)
                  )
                  :
                  descriptionTextFieldNoIndexOrChangeHandler(
                    'subcaption',
                    newMediaItem.subcaption,
                    ``,
                    2,
                    75,
                    'Your wittiest subcaption',
                    false,
                    setNewMediaItem,
                    newMediaItem,
                    0
                  )
                }

              </Box>

              {/* {advisoryTypography(
                `Captions and subcaptions can be edited in the 'Media' tab of your dashboard`
              )} */}

              {/* Create and Cancel Buttons */}
              <Box
                sx={{
                  width: selectedMediaItemDimension(width),
                  display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                }}
              >
                {doneAndCancelButtonsJSX(
                  'Done',
                  'Cancel',
                  doneButtonDisabled(),
                  false,
                  handleDone,
                  handleClose,
                  width < positionChangeWidthSm ? -2 : -4,
                  0,
                  0,
                  width,
                  'warning',
                  'secondary'
                )}
                
              </Box>
            </Box>
            :
            <Box
              sx={{
                mt: 1, pb: 6,
                width: '100%',
                maxWidth: '600px',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'flex-start',
                flexWrap: 'wrap',
              }}
            >
              {/* List of Media Items */}
              {user.media.map((listedMediaItem, listedMediaItemIndex) => (
                <Box 
                  key={listedMediaItemIndex}
                  sx={{
                    // backgroundColor: 'yellow',
                    width: '33%',
                    mb: 0,
                    display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: listedMediaItemIndex % 3 === 1 ? 'center' : listedMediaItemIndex % 3 === 0 ? 'flex-end' : 'flex-start',
                  }}
                >
                  {/* Media */}
                  <SelectMediaItem 
                    mediaItem={listedMediaItem} 
                    mediaItemIndex={listedMediaItemIndex} 
                    selectMediaItem={selectMediaItem}
                    mediaItemURLsInDatingProfileArray={mediaItemURLsInDatingProfileArray}
                    datingProfile={datingProfile}
                  />
                </Box>
              ))}

              <Box 
                sx={{
                  // backgroundColor: 'yellow',
                  width: '33%',
                  mb: 0,
                  display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: user.media.length % 3 === 0 ? 'flex-end' : user.media.length % 3 === 1 ? 'center' : 'flex-start',
                }}
              >
                <Box
                  onClick={handleAddNewMediaItem}
                  sx={{
                    my: 1, 
                    // mx: 1,
                    backgroundColor: 'gray',
                    width: selectMediaItemDimension(width),
                    height: selectMediaItemDimension(width),
                    boxShadow: 3, 
                    borderRadius: '5px', 
                    cursor: 'pointer',
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', 
                  }}
                >
                  <AddIcon 
                    color='primary'
                    sx={{
                      // boxShadow: 3, 
                      borderRadius: '50%',
                      border: 2, 
                      borderColor: 'black',
                      backgroundColor: 'white',
                      width: '40px', height: '40px',
                    }}
                  />
                </Box>

              </Box>

              {/* Add Dummy Boxes if necessary */}
              {/* {console.log('remainder ->', filteredMedia.length % 3)} */}
              {(user.media.length + 1) > 3 
              && (user.media.length + 1) % 3 > 0 
              &&
                ((user.media.length + 1) % 3 === 1 ? [1, 2] : [1]).map( dummy => (
                  dummyBoxWidth('33%', 0, dummy)
                ))
              }
            </Box>
          }

          {/* {advisoryTypography(
            `**Add more media items in the 'Media' tab`
          )} */}
          

          {errors.selectMediaItem &&
            standardErrorContainer(
              'There was an error updating your media item. Check your Internet connection and try again.',
              1,
              1
            )
          }
        </Box>
      </Box>
    </Modal>
  )
}